@if (isEnabled) {
    <div
        (click)="openChat()"
        class="group fixed bottom-0 z-50 mx-4 my-8 flex h-20 w-20 cursor-pointer items-center justify-center rounded-full border bg-blue-500 text-4xl text-white drop-shadow-lg transition-all hover:-translate-y-2 hover:bg-blue-700 ltr:right-0 rtl:left-0"
    >
        <i
            class="fa-duotone fa-robot transition-transform group-hover:scale-110"
        ></i>
    </div>
}
